import { LeaderboardModelledResponse, LeaderboardResponse } from '../../types/rewards';

export const getRewardsLeaderboardModalCreator = (
  response: LeaderboardResponse
): LeaderboardModelledResponse => {
  return {
    users: response.users.map((user) => ({
      userId: user.userId,
      userWallet: user.userWallet,
      totalPoints: user.totalPoints,
      totalRarePass: user.totalRarePass,
      lifetimePointsEarned: user.lifetimePointsEarned,
      mintedCount: user.mintedCount,
      rank: user.rank,
    })),
    page: response.page,
    pageSize: response.pageSize,
    total: response.total,
  };
};
